import * as z from 'zod'

import type { ContentsNeoStepConfigParams } from '@flows/configs/contents/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const wg_insured = (params: ContentsNeoStepConfigParams) =>
  ({
    schema: z.object({
      wg_insured: z.boolean(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contents:steps.contents.new.wg.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: 'wg_insured',
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.inputs.yes',
            },
            value: true,
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.inputs.no',
            },
            value: false,
          },
        ],
      },
      {
        type: 'infoBox',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contents:steps.contents.new.wg.info.text',
        },
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: 'wg_insured',
      valueToStepName: {
        true: 'wg_members',
        false: 'contents_natural_disasters',
      },
    },
  }) as const satisfies AnyStepConfiguration

export default wg_insured
